const vn = {
    addMember: 'Thêm thành viên',
    avatar: 'hình đại diện',
    phNumber: 'Số điện thoại',
    permissions: 'Quyền',
    isAdmin: 'Bạn có phải là quản trị viên hệ thống',
    acntExists: 'Tài khoản đã tồn tại',
    addSuccess: 'Thêm thành công',
    addFailed: 'thêm thất bại',
    tips: 'gợi ý',
    confirmAction: 'Bạn có chắc chắn muốn',
    disable: 'Vô hiệu hóa',
    enable: 'cho phép',
    bascInfoUp: 'Thông tin cơ bản được sửa đổi thành công',
    userPerSetSuc: 'Thiết lập quyền người dùng thành công',
    pwdChanged: 'Đặt lại mật khẩu hoàn tất',
    mobileChangeSuc: 'Thay đổi số điện thoại thành công',
    aginLogin: 'Vui lòng đăng nhập lại!',
    validaFailed: 'Xác minh không hoàn thành',
    pwd: 'mật khẩu',
    enterPwd: 'Xin vui lòng nhập mật khẩu',
    pwdMinLength: 'Mật khẩu phải có ít nhất 6 ký tự',
    plConfirmPwd: 'Vui lòng xác nhận mật khẩu của bạn',
    confirmPwd: 'Xác nhận mật khẩu',
    pwdDiff: 'Hai mật khẩu không nhất quán',
    reenterPwd: 'Vui lòng xác nhận lại mật khẩu',
    memberDetails: 'Chi tiết thành viên',
    basicInfo: 'Thông tin cơ bản',
    searchPrompt: 'Vui lòng nhập name1, name2, số điện thoại để tìm kiếm',
    sure: 'Chắc chắn',
    viewDetails: 'kiểm tra chi tiết',
    thisMember: 'Các thành viên',
    maxLengthTip: 'Nội dung vượt quá giới hạn độ dài tối đa!',
    changeStatusSucc: 'Hoạt động thành công!',
    phNumberTip: 'Vui lòng nhập số điện thoại',
    updateFail: 'Sửa đổi thất bại',
    userDataNoExistTip: 'Dữ liệu người dùng không tồn tại hoặc người dùng bị vô hiệu hóa',
    mobileEmpty: 'Số điện thoại không được để trống',
    userFetchFail: 'Lỗi lấy thông tin người dùng',
    name1: 'Tên1',
    name2: 'Tên2',
};

export default vn;